import { render, staticRenderFns } from "./TabVariants.vue?vue&type=template&id=3f43b800&scoped=true&"
import script from "./TabVariants.vue?vue&type=script&lang=js&"
export * from "./TabVariants.vue?vue&type=script&lang=js&"
import style0 from "./TabVariants.vue?vue&type=style&index=0&id=3f43b800&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f43b800",
  null
  
)

export default component.exports